import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TechnicianCard = ({ 
  technician, 
  onAssignService, 
  onViewDetails,
  onCallTechnician 
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'available':
        return 'bg-success/10 text-success';
      case 'busy':
        return 'bg-warning/10 text-warning';
      case 'offline':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'available':
        return 'Disponible';
      case 'busy':
        return 'En intervention';
      case 'offline':
        return 'Hors ligne';
      default:
        return 'Inconnu';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3 mb-3">
        <div className="relative">
          <Image
            src={technician?.avatar}
            alt={technician?.avatarAlt}
            className="w-12 h-12 rounded-full object-cover"
          />
          <div className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-card ${
            technician?.status === 'available' ? 'bg-success' :
            technician?.status === 'busy' ? 'bg-warning' : 'bg-error'
          }`} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground truncate">{technician?.name}</h3>
          <p className="text-sm text-muted-foreground">{technician?.specialty}</p>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(technician?.status)}`}>
          {getStatusLabel(technician?.status)}
        </span>
      </div>
      <div className="space-y-2 mb-3">
        <div className="flex items-center gap-2 text-sm">
          <Icon name="MapPin" size={16} className="text-muted-foreground" />
          <span className="text-foreground truncate">{technician?.currentLocation}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Briefcase" size={16} className="text-muted-foreground" />
          <span className="text-foreground">
            {technician?.todayServices} / {technician?.maxServices} interventions
          </span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Icon name="Star" size={16} className="text-warning" />
          <span className="text-foreground">{technician?.rating} ({technician?.reviewCount} avis)</span>
        </div>
      </div>
      <div className="w-full bg-muted rounded-full h-2 mb-3">
        <div 
          className="bg-primary h-2 rounded-full transition-all"
          style={{ width: `${(technician?.todayServices / technician?.maxServices) * 100}%` }}
        />
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Phone"
          onClick={() => onCallTechnician(technician?.id)}
          className="flex-1"
        >
          Appeler
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="UserPlus"
          onClick={() => onAssignService(technician?.id)}
          disabled={technician?.status !== 'available'}
          className="flex-1"
        >
          Assigner
        </Button>
      </div>
    </div>
  );
};

export default TechnicianCard;